import React, { useEffect, useState } from "react";
import { queryRelatedTypes } from "../firebase/fireQueries";
import { forArrayLength, objectToArray } from "../misc/helperfuncs";
import boxStore from "../stores/boxStore";
import MainStore from "../stores/MainStore";

const useHandleBoxTypes = () => {
  const { player, firstLoad } = MainStore();
  const { relatedBoxTypes } = boxStore();
  const [relatedTypes, setRelatedTypes] = useState([]);
  const [onlyOnce, setOnlyOnce] = useState(true);

  useEffect(() => {
    if (relatedBoxTypes) {
      setRelatedTypes(relatedBoxTypes);
    }
  }, [relatedBoxTypes]);

  function getBoxType(type, plural) {
    const objectArray = objectToArray(player.boxTypes);
    var found = objectArray.find((kv) => kv.value.names.singular === type);
    if (plural)
      found = objectArray.find((kv) => kv.value.names.plural === type);

    return player.boxTypes[found.value.names.plural];
  }

  function getAllBoxTypes(singular) {
    const objectArray = objectToArray(player.boxTypes);
    if (!singular) return objectArray.map((kv) => kv.key);
    else return objectArray.map((kv) => kv.value.names.singular);
  }

  function getPluralType(type) {
    const objectArray = objectToArray(player.boxTypes);

    var found = objectArray.find((kv) => kv.value.names.singular === type);
    if (!found)
      found = objectArray.find((kv) => kv.value.names.plural === type);
    return player.boxTypes[found.value.names.plural].names.plural;
  }

  function getSingularType(pluralType) {
    const playerType = player.boxTypes[pluralType];
    if (playerType) return player.boxTypes[pluralType].names.singular;
    else {
      const foundRelated = relatedBoxTypes.find(
        (t) => t.names.plural === pluralType
      );
      const singularName = foundRelated.names.singular;
      return singularName;
    }
  }

  return {
    getPluralType,
    getSingularType,
    getBoxType,
    getAllBoxTypes,
    relatedTypes,
  };
};

export default useHandleBoxTypes;
